module.exports = __webpack_public_path__ + "img/4-2.343aad3c.png";